import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { AgRendererComponent } from 'ag-grid-angular';


@Component({
    standalone: true,
    selector: 'ag-link-renderer',
    templateUrl: './ag-link-renderer.component.html',
    styleUrls: ['./ag-link-renderer.component.scss'],
    imports: [CommonModule]
})
export class AgLinkRendererComponent implements AgRendererComponent {
    params: any;

    constructor(private readonly router: Router,
            public readonly userAuthService: UserAuthService 
    ) {
    }

    agInit(params: any): void {
        this.params = params;
    }

    refresh(params: any): boolean {
        return false;
    }

    onClick() {
        if (this.params?.data?.Id) {
            if (this.params?.data?.ReleaseType === 'Hotfix' || this.params?.data?.ReleaseType === 'Patch') {
                   this.router.navigate([`/release/modify-hotfix/${this.params?.data?.Id}`]);
            }
            else {
                this.router.navigate([`/release/modify-release/${this.params?.data?.Id}`]);
            }
        }
    }
}